export default {
  methods: {
    convertToUTC(scheduledDate) {
      if (!scheduledDate) {
        return null;
      }
      var fullDate = new Date(scheduledDate);
      var selectedHour = this.scheduledHour.slice(0, 2);
      var utcTimeStamp = new Date(
        fullDate.getFullYear(),
        fullDate.getMonth(),
        fullDate.getDate(),
        selectedHour
      ).getTime();
      return utcTimeStamp;
    },
  },
};
